import { viewerOptions } from "../viewer";
import * as SmartDrawings from "../smartDrawings";

declare global {
    namespace THREE {
        interface Vector3 {
            toModelUnits(): THREE.Vector3;
            toViewerUnits(): THREE.Vector3;
            toSD(): SmartDrawings.Vector3;
        }

        interface Vector4 {
            toRgba(): THREE.Vector4;
        }
    }
}

THREE.Vector3.prototype.toModelUnits = function () {
    return new THREE.Vector3(this.x, this.y, this.z).multiplyScalar(viewerOptions.unitData.viewerToModelScale);
}

THREE.Vector3.prototype.toViewerUnits = function () {
    return new THREE.Vector3(this.x, this.y, this.z).multiplyScalar(viewerOptions.unitData.modelToViewerScale);
}

THREE.Vector3.prototype.toSD = function (): SmartDrawings.Vector3 {
    return { x: this.x, y: this.y, z: this.z };
}

THREE.Vector4.prototype.toRgba = function (): THREE.Vector4 {
    return this.multiplyScalar(1 / 255);
}